import { render, staticRenderFns } from "./relatedModal.vue?vue&type=template&id=56c5f3dc&"
import script from "./relatedModal.vue?vue&type=script&lang=js&"
export * from "./relatedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports